export const GET_TRACKING_PAGE = 'getTrackingPage';

export default {
  GET_TRACKING_PAGE,
};
